import { FC, useState, MouseEvent, useRef, useEffect } from "react";
import { PickerProjectI } from "./models/models";
import Icon from "components/Elements/Icon/Icon";
import { useContent } from "contexts/contentContext/contentContext";
import Image from "../../../Elements/Image/Image";
import { useTransofrmedDate } from "utils/dateViewTransformer";
import { pickerStatusKeys } from "./helpers";
import useMediaQueries from "hooks/useMediaQueries";
import { EventTypes, pickerStatusColors } from "./models/enums";
import useOnClickOutside from "hooks/useOnClickOutside";
import Tooltip from "components/Elements/Tooltip/Tooltip";
import usePickerQueryParamActions from "./usePickerQueryParamActions";
//@ts-ignore
import config from "config";
import PickerActions from "./PickerActions.tsx";
import { createPortal } from "react-dom";

//@ts-ignore
import styles from "./styles.module.scss";

type PickerListMailPropTypes = {
  item: PickerProjectI;
  index: number;
};

const PickerListMail: FC<PickerListMailPropTypes> = (props) => {
  const { item, index } = props;
  const { getTextByKey } = useContent();
  const { returnDate: creationDate, returnTime: creationTime } =
    useTransofrmedDate({ date: item.CreationDate });
  const { mobileCondition } = useMediaQueries();
  const [more, setMore] = useState(false);
  const ref = useRef(null);
  const wrapperRef = useRef(null);
  const { openIframe, getEditLink, getViewLink } = usePickerQueryParamActions();
  const id = `picker-project-${getEditLink(
    item?.PickerGalleryID,
    item?.Subdomain
  )}`;
  const [showActionIcon, setShowActionIcon] = useState(false);

  useEffect(() => {
    if (wrapperRef.current) {
      const el = document.getElementById(id);
      if (el) {
        setShowActionIcon(true);
      }
    }
  }, [wrapperRef.current]);

  useOnClickOutside(ref, () => {
    setMore(false);
  });

  const toggleMore = () => setMore((prev) => !prev);

  const handleOpenIframe = (
    e: MouseEvent<HTMLAnchorElement>,
    type: "view" | "edit"
  ) => {
    e.preventDefault();
    openIframe(type, {
      galleryId: item?.PickerGalleryID,
      subdomain: item?.Subdomain,
    });
  };

  return !mobileCondition ? (
    <div id={id} className={styles.actionsHandler} ref={wrapperRef}>
      <li
        className={styles.mailWrapper}
        style={{ animationDelay: `${index / 10}s` }}
      >
        <div className={styles.header}>
          <a
            className={styles.title}
            href={getEditLink(item?.PickerGalleryID, item?.Subdomain)}
            onClick={(e) => handleOpenIframe(e, "edit")}
          >
            #{item.PickerProjectID} {item.ProjectName}
          </a>
          {pickerStatusKeys[item.Status] ? (
            <div
              className={styles.status}
              style={{
                border: `1px solid ${
                  pickerStatusColors[pickerStatusKeys[item.Status]]
                }`,
                color: pickerStatusColors[pickerStatusKeys[item.Status]],
              }}
            >
              {/*@ts-ignore*/}
              <Tooltip
                tooltipTextKey={
                  pickerStatusKeys[item.Status] + "-picker-status-tooltip"
                }
              >
                {getTextByKey(pickerStatusKeys[item.Status] + "-picker-status")}
              </Tooltip>
            </div>
          ) : null}
          {wrapperRef.current && document.getElementById(id)
            ? createPortal(
                <PickerActions
                  editLink={getEditLink(item?.Subdomain, item?.PickerGalleryID)}
                  shareLink={getViewLink(
                    item?.Subdomain,
                    item?.PickerGalleryID
                  )}
                  handleOpenIframe={handleOpenIframe}
                  pickerGalleryID={item?.PickerGalleryID}
                />,
                document.getElementById(id)!
              )
            : null}
        </div>
        <div className={styles.dataWrapper}>
          {item.ThumbImg ? (
            <div
              className={styles.thumbImg}
              style={{
                backgroundImage: `url(${item.ThumbImg})`,
              }}
            />
          ) : (
            <Image name="nothumb" className={styles.noThumbImg} />
          )}
          <ul className={styles.data}>
            <li>
              <GallerySource
                gallerySrc={item?.GallerySrc!}
                jmData={item?.jm_data!}
                SourcePhotosLink={item?.SourcePhotosLink}
              />
            </li>
            <li>
              {getTextByKey("picker-email")}: {item.ClientEmail || "N/A"}
            </li>
            <li>
              <span>
                {getTextByKey("size")}: {item.Size || "N/A"}
              </span>
            </li>
            <li>
              {getTextByKey("picker-event-date")}: {item.EventDate || "N/A"}
            </li>
            <li>
              {/*@ts-ignore*/}
              <Tooltip
                tooltipText={
                  item.CollectionsForProject?.map(({ name }) => name)?.join(
                    ", "
                  ) || "0"
                }
              >
                {getTextByKey("picker-collections")}:{" "}
                <span className={styles.textEllipsis}>
                  {item.CollectionsForProject?.map(({ name }) => name)?.join(
                    ", "
                  ) || 0}
                </span>
              </Tooltip>
            </li>
            <li>
              {creationDate} {creationTime}
            </li>
            <li>
              {getTextByKey("picker-phone")}: {item.ClientPhone || "N/A"}
            </li>
            <li>
              <span>
                {getTextByKey("picker-files")}: {item.NumberOfFiles || 0}
              </span>
            </li>
            <li>
              {getTextByKey("picker-event-type")}: {EventTypes[+item.EventType]}
            </li>
            <li>
              {getTextByKey("picker-selected")}:{" "}
              {item.TotalColSelected.trim() || "0 / 0"}
            </li>
          </ul>
        </div>
      </li>
    </div>
  ) : (
    <li
      className={styles.mailWrapperMobile}
      style={{ animationDelay: `${index / 10}s` }}
      ref={ref}
    >
      <MailHeader
        title={`#${item?.PickerProjectID} ${item?.ProjectName || ""}`}
        editLink={getEditLink(item?.PickerGalleryID, item?.Subdomain)}
        shareLink={getViewLink(item?.PickerGalleryID, item?.Subdomain)}
        handleOpenIframe={handleOpenIframe}
        PickerGalleryID={item?.PickerGalleryID}
      />
      <div className={styles.middleSectionMobile}>
        <ThumbImg src={item?.ThumbImg} />
        <div>
          <div>
            {item?.GalleryName ||
              item?.ProjectName ||
              getTextByKey("no-gallery-title")}
          </div>
          <div>{item?.CreationDate}</div>
        </div>
      </div>
      <ul
        className={styles.dataMobile}
        style={{ height: more ? "88px" : "44px" }}
      >
        <Icon
          name="arrow-down"
          gray
          iconClass={[
            styles.moreIcon,
            styles[more ? "expanded" : "collapsed"],
          ].join(" ")}
          onClick={toggleMore}
        />
        <li className={styles.dataRow}>
          <span>{getTextByKey("picker-email")}: </span>
          <span>{item.ClientEmail || "N/A"}</span>
        </li>
        <li className={styles.dataRow}>
          <span>{getTextByKey("picker-phone")}: </span>
          <span>{item.ClientPhone || "N/A"}</span>
        </li>
        <li className={styles.dataRow}>
          <span>{getTextByKey("size")}: </span>
          <span>{item.Size || "N/A"}</span>
        </li>
        <li className={styles.dataRow}>
          <span>{getTextByKey("files")}: </span>
          <span>{item.NumberOfFiles || 0}</span>
        </li>
        <li className={styles.dataRow}>
          <span>{getTextByKey("picker-event-type")}: </span>
          <span>{EventTypes[+item.EventType]}</span>
        </li>
        <li className={styles.dataRow}>
          <span>{getTextByKey("picker-event-date")}: </span>
          <span>{item?.EventDate || "N/A"}</span>
        </li>
      </ul>
      <div className={styles.bottomSectionMobile}>
        <span>
          {getTextByKey("picker-selected")}:{" "}
          {item.TotalColSelected.trim() || "0 / 0"}
        </span>
        {pickerStatusKeys[item.Status] ? (
          <div
            className={styles.status}
            style={{
              border: `1px solid ${
                pickerStatusColors[pickerStatusKeys[item.Status]]
              }`,
              color: pickerStatusColors[pickerStatusKeys[item.Status]],
            }}
          >
            {getTextByKey(pickerStatusKeys[item.Status] + "-picker-status")}
          </div>
        ) : null}
      </div>
    </li>
  );
};

// Mobile mail header

const MailHeader: FC<{
  title: string;
  editLink: string;
  shareLink: string;
  PickerGalleryID: string;
  handleOpenIframe: (
    e: MouseEvent<HTMLAnchorElement>,
    type: "view" | "edit"
  ) => void;
}> = ({ title, editLink, shareLink, handleOpenIframe, PickerGalleryID }) => {
  const id = `picker-project-${editLink}`;
  const [element, setElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        setElement(el);
      }
    }, 1000);
  }, [id]);

  return (
    <div className={styles.header}>
      <div>
        <a
          className={styles.title}
          href={editLink}
          onClick={(e) => handleOpenIframe(e, "edit")}
        >
          {title}
        </a>
      </div>
      <span />
      {element
        ? createPortal(
            <PickerActions
              editLink={editLink}
              shareLink={shareLink}
              handleOpenIframe={handleOpenIframe}
              pickerGalleryID={PickerGalleryID}
            />,
            element
          )
        : null}
    </div>
  );
};

const GallerySource: FC<{
  gallerySrc: string;
  jmData: string;
  SourcePhotosLink: string;
}> = ({ gallerySrc, jmData, SourcePhotosLink }) => {
  const { getLanguage } = useContent();
  const mailData = jmData && JSON.parse(jmData);
  const galleryLink = `${config!.baseurl}/${getLanguage()}/gallery/${
    mailData?.EncryptedMailId
  }`;
  const { getTextByKey } = useContent();

  return (
    <div className={styles.gallerySrc}>
      {gallerySrc === "JM" && (
        <div>
          <a
            href={galleryLink}
            target="_blank"
            rel="noreferrer"
            className={styles.createdWith}
          >
            <span>
              {getTextByKey("picker-created-with").split(" ").join(": ")}
            </span>
            {/*@ts-ignore*/}
            <Tooltip tooltipTextKey="JUMBOmail">
              <Icon name="newInbox/Products/mail" />
            </Tooltip>
          </a>
        </div>
      )}
      {gallerySrc === "JF" && (
        <div>
          <span className={styles.createdWith}>
            <span>
              {getTextByKey("picker-created-with").split(" ").join(": ")}
            </span>
            {/*@ts-ignore*/}
            <Tooltip tooltipTextKey="JUMBOpicker">
              <Icon name="newInbox/Products/picker" />
            </Tooltip>
          </span>
        </div>
      )}
      {gallerySrc === "GD" && (
        <div>
          <a
            href={SourcePhotosLink}
            target="_blank"
            rel="noreferrer"
            className={styles.createdWith}
          >
            <span>
              {getTextByKey("picker-created-with").split(" ").join(": ")}
            </span>
            {/*@ts-ignore*/}
            <Tooltip tooltipTextKey="Google Drive">
              <Icon name="drive" />
            </Tooltip>
          </a>
        </div>
      )}
    </div>
  );
};

// Mobile gallery preview image

const ThumbImg: FC<{ src: string }> = ({ src }) =>
  src ? (
    <div
      className={styles.thumbImg}
      style={{
        backgroundImage: `url(${src})`,
      }}
    />
  ) : (
    <Image name="nothumb" className={styles.noThumbImg} />
  );

export default PickerListMail;
